import { Main, systemNames } from '@user-portal/wikr-analytics';

export const initAnalytics = () => {
  Main.initSystems({
    activeSystems: [
      {
        name: systemNames.amazon,
        id: import.meta.env.AMAZON_ID,
        config: {
          releaseDate: import.meta.env.RELEASE_DATE,
          streamName: import.meta.env.AWS_DELIVERY_STREAM_NAME,
          envMode: import.meta.env.ENV,
        },
      },
    ],
  });
};
